<template>
	<!-- 对账记录 -->
	<div>
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="submitForm">
				<el-form-item>
				    <el-date-picker
				        v-model="rangeDate"
				        type="daterange"
				        range-separator="至"
				        start-placeholder="开始日期"
				        end-placeholder="结束日期"
				        value-format="yyyy-MM-dd"
				        :picker-options="pickerOptions"
				        @change="pickerChange"
				    ></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-select size v-model="submitForm.status" clearable placeholder="请选择解决状态">
						<el-option label="已解决" value="1"></el-option>
						<el-option label="未解决" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="handleSearch(submitForm)">查询</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<el-table :data="centerList" size="mini" border style="width: 100%" v-loading="loading">
				<!-- 序号 -->
				<el-table-column header-align="center" align="center" fixed prop="id" label="ID" >
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="mercErrNo" label="退汇编号" >
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="merchantNo" label="商户编号">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="name" label="商户名称" >
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="refundReason" label="退汇原因" >
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="status_text" label="状态" >
				</el-table-column>
        <el-table-column header-align="center" align="center" prop="createTime" label="创建时间">
        </el-table-column>
				<el-table-column header-align="center" align="center" prop="payDate" label="出款时间" >
				</el-table-column>
        <el-table-column header-align="center" align="center" prop="complete_time" label="解决时间" >
        </el-table-column>

				<!-- 操作 -->
<!--				<el-table-column header-align="center" align="center" fixed="right" label="操作" width="200">-->
<!--					<template slot-scope="scope">-->
<!--						<span v-if="scope.row.status_text=='已解决'" @click="statusChange(scope.row)">-</span>-->
<!--						<el-button-->
<!--							v-if="scope.row.status_text=='未解决'"-->
<!--						        @click="statusChange(scope.row)"-->
<!--						        type="text"-->
<!--						        size="small"-->
<!--						        slot="reference"-->
<!--						>解决</el-button>-->
<!--					</template>-->
<!--				</el-table-column>-->
			</el-table>
			<!-- 分页部分 -->
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:page-sizes="[10,20,50,100]" :current-page="currentPage" :page-size="pageSize" :total="total"
				layout="total, sizes, prev, pager, next, jumper"></el-pagination>
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				submitForm: {
					start_time: '',
					end_time: '',
					page: 1,
					limit: 10
				},
				centerList: [],
				currentPage: 1, //当前页码
				pageSize: 10, //条数
				total: 0, //总数
				loading: false,
				downLoading: false, //导出loading
				pickerOptions: {},
				rangeDate:[],
			}
		},
		mounted() {
			this.getData({
				page: 1,
				limit: 10
			})
		},
		methods: {

			handleSearch(searchFrom) { //搜索
				this.currentPage = 1;
				searchFrom.page = 1;
				this.getData(searchFrom);
			},
			handleCurrentChange(page) { //当前选中页
				this.currentPage = page;
				this.submitForm.page = page;
				this.submitForm.limit = this.pageSize;
				this.getData(this.submitForm);
			},
			handleSizeChange(limit) { //条数
				this.currentPage = 1;
				this.pageSize = limit;
				this.submitForm.page = 1;
				this.submitForm.limit = limit;
				this.getData(this.submitForm);
			},
			handleDefaultTime() { //默认获取三十天
			    let date =this.$moment().endOf('day').format('x');
			    this.submitForm.end_time = this.$moment(Number(date)).format("YYYY-MM-DD HH:mm:ss");
			    this.submitForm.start_time = this.$moment(Number(date) - 3600 * 1000 * 24 * 31 +1).format("YYYY-MM-DD HH:mm:ss");
			    this.rangeDate = [this.submitForm.start_time, this.submitForm.end_time];
			},
			pickerChange(DateArr) { //时间选择器
			    this.submitForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
			    this.submitForm.end_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");
			    console.log(this.submitForm.end_time)
			    this.rangeDate = [this.submitForm.start_time, this.submitForm.end_time];
			},
			getData(params) { //获取数据
				this.$api.post("transaction/merchantRefundList", params, res => {
					if (res.code == 0) {
						let data = res.data;
						this.total = data.count; //总数
						this.centerList = res.data.list;
						// this.centerList = [];
						//渲染结束后取消加载
					} else {
						this.$message.error(res.msg);
					}
				})
			},
			statusChange(row) { //改变状态
				console.log(row)
				this.$confirm('确定修改为已解决状态, 是否继续?', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
				  this.$api.post('transaction/merchantRefundStatusEdit', {
				  	id: row.id,
				  }, res => {
				  	if (res.code == 0) {
				  		this.$message.success(res.msg);
				  	} else {
				  		this.$message.error(res.msg);
				  	}
				  })
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});          
				});
			},
		}
	}
</script>

<style scoped lang="scss">
</style>
